import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelpDocRoutingModule } from 'src/app/modules/help/help-routing.module';
import { HelpDocumentionComponent } from './help-documention/help-documention.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { SharedModule}  from 'src/app/modules/shared/shared.module'

@NgModule({
  declarations: [HelpDocumentionComponent],
  imports: [
    CommonModule,
    HelpDocRoutingModule,
    MatSidenavModule,
    SharedModule
  ]
})
export class HelpModule { }
